import React from "react";
import ReactSelect from "react-select";

/**
 * Drop-in replacement for react-select used across the admin panel.
 *
 * Problem it fixes: by default react-select renders its menu inline in the DOM,
 * so any ancestor with `overflow: hidden/auto` (our form cards) clips the open
 * dropdown — the options list gets cut off at the card edge.
 *
 * This wrapper portals the menu to <body> (so no ancestor can clip it) and
 * lifts its z-index above the cards/modals. It forwards every prop, so existing
 * usages (`options`, `value`, `styles`, `isMulti`, `onChange`, …) keep working
 * unchanged — callers only had to switch the import.
 */
const PortalSelect = ({ styles, menuPortalTarget, menuPosition, ...rest }) => {
  const mergedStyles = {
    ...(styles || {}),
    // Preserve any menuPortal styling a caller supplied, then force a high z-index.
    menuPortal: (base, state) => ({
      ...base,
      ...(typeof styles?.menuPortal === "function"
        ? styles.menuPortal(base, state)
        : {}),
      zIndex: 9999,
    }),
  };

  return (
    <ReactSelect
      menuPortalTarget={
        menuPortalTarget !== undefined
          ? menuPortalTarget
          : typeof document !== "undefined"
          ? document.body
          : null
      }
      menuPosition={menuPosition || "fixed"}
      styles={mergedStyles}
      {...rest}
    />
  );
};

export default PortalSelect;
